// Constant Data for Seller::Product

export const CURATION_STATUS = {
  ACCEPTED  : 'accepted',
  REJECTED  : 'rejected',
  PENDING   : 'pending',
  NOT_FOUND : 'not_found'
}

export const CONFIRM_PRICE_STATUS = {
  PENDING          : 'pending',
  SELLER_CONFIRMED : 'seller_confirmed',
  SELLER_DISAGREES : 'seller_disagrees'
}

export const PHOTO_UPLOAD_STATUS = {
  PENDING   : 'pending',
  COMPLETED : 'completed'
}

export const PUT_AWAY_STATUS = {
  PENDING  : 'pending',
  COMPLETE : 'complete'
}

export const LIVE_PROCESS_STATUS = {
  PENDING    : 'pending',
  READY_LIVE : 'ready_live',
  COMPLETED  : 'completed',
  DISABLED   : 'disabled'
}

export const INBOUND_SOURCE = {
  SELLER    : 'seller',
  ES_STORE  : 'es_store',
  ES_JASTIP : 'es_jastip',
  ES_PO     : 'es_po',
  SCRAPER   : 'scraper',
  PARTNER   : 'partner'
}

export const BRAND_CLASSIFICATION = {
  ASPIRATIONAL_LUXURY : 'Aspirational Luxury',
  HIGH_END_LUXURY     : 'High End Luxury',
  LUXURY              : 'Luxury',
  BRANDED             : 'Branded',
  HIGH_STREET         : 'High Street'
}

export const MARKETPLACE_MINIMUM_PRICE = {
  LUXURY  : 1700000,
  BRANDED : 500000
}

export const CONVERT_TO_MP_MINIMUM_PRICE = 60000